export function menu() {
	const menuButton = document.querySelectorAll(".js--menu-button");
	const modalMenu = document.querySelectorAll(".modal--menu");
	function modalToggle(menu) {
		if (!menu.open) {
			menu.showModal();
			return;
		}
		if (menu.open) {
			menu.close();
		}
	}
	menuButton.forEach((button) =>
		button.addEventListener("click", (e) => {
			modalMenu.forEach((menu) => {
				modalToggle(menu);
			});
		})
	);
	modalMenu.forEach((menu) => {
		const closeButton = menu.querySelector(".modal__button--close");
		closeButton.addEventListener("click", (e) => {
			modalToggle(menu);
		});
	});
	let $dropdowns = $('.has-expand');
	$dropdowns.click(function() {
		$dropdowns.not($(this)).find('.sub-menu').hide();
		$dropdowns.not($(this)).find('.expanded').removeClass('expanded');
		$(this).find('.sub-menu').toggle();
		$(this).find('a').toggleClass('expanded');
		//return false;
	});

}

export function menuButton() {
	const modalMenus = document.querySelectorAll(".menu--modal.menu--primary > li > a");
	modalMenus.forEach((toggle) => {
		toggle.addEventListener("click", (e) => {
			// console.log(e.target);
			if (e.target.parentNode.classList.contains("menu-item--cta")) return;
			e.preventDefault();
			if (e.target.parentNode.classList.contains("menu-item--active")) {
				e.target.parentNode.classList.remove("menu-item--active");
				return;
			}

			e.target.parentNode.parentNode.querySelectorAll(".menu-item--active").forEach((item) => {
				item.classList.remove("menu-item--active");
			});
			if (!e.target.parentNode.classList.contains("menu-item--active")) {
				e.target.parentNode.classList.add("menu-item--active");
			}
		});
	});
	// console.log(modalMenus);
}

// ****
// Live Ajax Search
// ****
    
jQuery(window).scroll(function() {
    jQuery('.searchwp-live-search-results').attr("aria-expanded","false");
    jQuery('.searchwp-live-search-results').removeClass("searchwp-live-search-results-showing");
});
jQuery(document).ready(function($) {
  
  //change <a> tag to <div> for search menu <li>
  (function($) {
	  jQuery.fn.changeElementType = function(newType) {
      var attrs = {};

		  jQuery.each(this[0].attributes, function(idx, attr) {
          attrs[attr.nodeName] = attr.nodeValue;
      });

      this.replaceWith(function() {
          return $("<" + newType + "/>", attrs).append($(this).contents());
      });
    };
  })(jQuery);
	jQuery(".search-bar a").changeElementType("div");
  
  //go directly to search page for screen sizes
	jQuery(".search-bar-icon").click(function(){
    window.location.href = "/?s=";
  });
});